import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'customdateformat'
})
export class CustomdateformatPipe implements PipeTransform {

  transform(date: any, format: string): any {
    if (date) {
     return moment(new Date(date)).format(format);
    }
  }

}


@Pipe({
  name: "TwodCloseTimeFormat"
})
export class TwodCloseTimeFormatPipe implements PipeTransform {

  // constructor(@Inject(forwardRef(() => TwodCloseTimeComponent)) private comp: TwodCloseTimeComponent) {

  // }
  transform(value: number): string {
    // const hours: number = Math.floor(value / 3600);
    // const minutes: number = Math.floor((value % 3600) / 60);
    const hours: number = Math.floor(value / 3600);
    const minutes: number = Math.floor((value % 3600) / 60);
    const seconds: number = Math.floor(value % 60);
    if (hours >= 0) {
      return (
        ("00" + hours).slice(-2) +
        ":" +
        ("00" + minutes).slice(-2) +
        ":" +
        ("00" + seconds).slice(-2)
        //("00" + Math.floor(value - minutes * 60)).slice(-2)
      );
    } 
    

  }
}
